export const SUPPORT_PHONE = '+919403355204';
export const SUPPORT_EMAIL = 'help@studway.in';
export const SUPPORT_MESSAGE = 'Hello HostelDesk Support, I need help with my HostelDesk account. Please assist me with my issue.';
export const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_PHONE.slice(1)}?text=${encodeURIComponent(SUPPORT_MESSAGE)}`;

// Tutorial links are supplied by platform support settings, never arbitrary embeds.
export function youtubeTutorialUrl(value) {
  try {
    const url = new URL(String(value || '').trim());
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
    if (!['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be'].includes(url.hostname)) return null;
    return url.href;
  } catch { return null; }
}

export function youtubeEmbedUrl(value) {
  const safe = youtubeTutorialUrl(value);
  if (!safe) return null;
  const url = new URL(safe);
  const id = url.hostname === 'youtu.be' ? url.pathname.slice(1) : url.pathname === '/watch' ? url.searchParams.get('v') : url.pathname.match(/^\/(?:shorts|embed)\/([^/]+)$/)?.[1];
  return /^[A-Za-z0-9_-]{11}$/.test(id || '') ? `https://www.youtube-nocookie.com/embed/${id}` : null;
}
